// removed by extract-text-webpack-plugin
module.exports = {"carousel-container":"carousel-container___1sJBH","similar-items":"similar-items___vhLDK","similar-items-header":"similar-items-header___3qTUB","center-text":"center-text___1oJV_","similar-grid":"similar-grid___3ghMy","similar-cards":"similar-cards___2pgbe","see-similar-cta":"see-similar-cta___27p_v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SimilarItems/SimilarItems.scss
// module id = blov
// module chunks = 57